import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";
import { SearchkitComponent, PageSizeAccessor, RenderComponentPropType, renderComponent } from "../../../core";

var map = require("lodash/map");

var defaults = require("lodash/defaults");

import { Select } from "../../ui";
export var PageSizeSelector =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(PageSizeSelector, _SearchkitComponent);

  function PageSizeSelector() {
    _classCallCheck(this, PageSizeSelector);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageSizeSelector).apply(this, arguments));
  }

  _createClass(PageSizeSelector, [{
    key: "getPageSizeAccessor",
    value: function getPageSizeAccessor() {
      return this.searchkit.getAccessorByType(PageSizeAccessor);
    }
  }, {
    key: "setSize",
    value: function setSize(size) {
      var pageSizeAccessor = this.getPageSizeAccessor();

      if (size) {
        pageSizeAccessor.setSize(Number(size));
        this.searchkit.performSearch();
      }
    }
  }, {
    key: "setItems",
    value: function setItems(sizes) {
      this.setSize(sizes[0]);
    }
  }, {
    key: "render",
    value: function render() {
      var pageSizeAccessor = this.getPageSizeAccessor();

      if (pageSizeAccessor) {
        var options = map(this.props.options, function (option) {
          return {
            key: option,
            label: option
          };
        });
        var selectedSize = pageSizeAccessor.getSize();
        var _this$props = this.props,
            mod = _this$props.mod,
            className = _this$props.className;
        return renderComponent(this.props.listComponent, {
          mod: mod,
          className: className,
          disabled: !this.hasHits(),
          items: options,
          selectedItems: [selectedSize],
          toggleItem: this.setSize.bind(this),
          setItems: this.setItems.bind(this),
          urlBuilder: function urlBuilder(_item) {},
          translate: this.translate
        });
      }

      return null;
    }
  }]);

  return PageSizeSelector;
}(SearchkitComponent);
PageSizeSelector.defaultProps = {
  listComponent: Select
};
PageSizeSelector.propTypes = defaults({
  listComponent: RenderComponentPropType,
  options: PropTypes.arrayOf(PropTypes.number).isRequired
}, SearchkitComponent.propTypes);